import Image from 'next/image';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { cn, getColorway } from 'utils/styles';
import type { HeroBentoCardSharedProps, HeroBentoLogoProps } from './types';

type Props = HeroBentoLogoProps & HeroBentoCardSharedProps;

const HeroBentoLogo = ({ sys, media, cardColorway }: Props) => {
  if (!media?.url) return null;

  return (
    <div
      className={cn(
        'flex items-center justify-center overflow-hidden rounded-3xl px-6 py-8 md:h-[150px]',
        getColorway(cardColorway),
      )}
      data-testid="hero-bento-logo"
      {...liveUpdateAttrs(sys?.id, 'media')}>
      <Image
        src={media.url}
        alt={media.description || media.title}
        width={media.width ?? 200}
        height={media.height ?? 100}
        className="max-h-full max-w-full object-contain"
      />
    </div>
  );
};

export default HeroBentoLogo;
